
define('template!portalUsersListTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<table class="table portal-users-table">\n  <thead>\n    <tr>\n      <th>' +
((__t = ( _.i18n('common.email', null, 'Email') )) == null ? '' : __t) +
'</th>\n      <th>' +
((__t = ( _.i18n('common.name', null, 'Name') )) == null ? '' : __t) +
'</th>\n      <th>' +
((__t = ( _.i18n('common.status', null, 'Status') )) == null ? '' : __t) +
'</th>\n      <th>' +
((__t = ( _.i18n('portalUsers.lastLogin', null, 'Last sign in') )) == null ? '' : __t) +
'</th>\n      <th class="notify-col" title="' +
((__t = ( _.i18n('portalUsers.notifyHint', null, 'Gets an email each time a new order lands on the portal') )) == null ? '' : __t) +
'">' +
((__t = ( _.i18n('portalUsers.notify', null, 'New order emails') )) == null ? '' : __t) +
'</th>\n      <th class="actions-col"></th>\n    </tr>\n  </thead>\n  <tbody></tbody>\n</table>\n';

}
return __p
};});

